module.exports = __webpack_public_path__ + "static/media/explore.cd91a481.svg";